<script lang="ts">
	import { compactFingerprint } from '$lib/pgp';

	interface Props {
		fingerprint: string;
	}

	let { fingerprint }: Props = $props();

	let copied = $state(false);
	let copyError = $state(false);

	const compact = $derived(compactFingerprint(fingerprint));

	async function copyFingerprint() {
		copied = false;
		copyError = false;

		try {
			await navigator.clipboard.writeText(compact);
			copied = true;
		} catch {
			copyError = true;
		}
	}
</script>

<div class="fingerprint">
	<p class="fingerprint-label">Published fingerprint</p>
	<code class="fingerprint-value">{fingerprint}</code>
	<div class="fingerprint-actions">
		<button class="button button-secondary" type="button" onclick={copyFingerprint}>
			Copy fingerprint
		</button>
		<p class="fingerprint-status" aria-live="polite">
			{#if copied}
				Copied without spaces. Compare every character with what your software shows.
			{:else if copyError}
				Copy failed. Select the fingerprint and copy it manually.
			{:else}
				Spacing does not change the fingerprint. Compare it in full before trusting the key.
			{/if}
		</p>
	</div>
</div>
